import React, { PropsWithChildren } from "react";
import { Skeleton } from "antd";

/**
 * Compact in-card loading placeholders for invite/auth waits.
 * @param {PropsWithChildren} props Optional extra content under the skeleton.
 */
const SimpleLoader = (props: PropsWithChildren) => {
  return (
    <div className="w-full py-2">
      <Skeleton active paragraph={{ rows: 4 }} />
      <div>{props.children}</div>
    </div>
  );
};

export default SimpleLoader;
